/**
 * This function replaces all occurences of shortcodes in the string. We are
 * currently use shortcodes in format `{{shortcodeName}}`.
 *
 * To replcae a shortcode you need to pass an object with matching key to
 * shortcode.
 *
 * @example replaceShortcodes("http://example.com/{{target}}", { target: "hello"}) // will produce "http://example.com/hello"
 */
export const replaceShortcodes = (string: string, variables: any) => {
    return string.replace(/{{(.*?)}}/g, (_, g) =>
        variables && variables[g] ? variables[g] : ` not available {{ ${g} }} `,
    );
};
